import React from "react";

const Button = ({ label }) => {
    return (
        <div>
            <button
                type='submit'
                className='text-md w-full rounded-lg bg-main-500 px-5 py-2.5 text-center text-white sm:w-auto'
            >
                {label}
            </button>
        </div>
    );
};

export default Button;
